import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import AgentGroupListItem from "./AgentGroupListItem";

import { RequestAgentGroups } from "../../../../../store/actions/integrationsActions";

import "./styles.scss";

const AgentGroupList = ({ selectedHost }) => {
  const dispatch = useDispatch();

  const agentGroups = useSelector((state) => state.integrations.agentGroups);

  useEffect(() => {
    dispatch(RequestAgentGroups(selectedHost));
  }, [dispatch, selectedHost]);

  return (
    <div className="agent-group__list">
      {agentGroups?.map((item) => (
        <AgentGroupListItem key={item.id} groupItem={item} selectedHost={selectedHost} />
      ))}
    </div>
  );
};

export default AgentGroupList;
